import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDStack,
} from '@facet-wealth/design';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { dataAttrs } from 'Helpers/Testing';
import { QuizWrapperLayout } from 'Views/FreemiumEntry/HasRelationship/Content/Components/QuizWrapperLayout';
import { ProgressBar } from './ProgressBar';
import { QuestionCard } from './QuestionCard';

const PicklistQuestion = ({ setLink }) => {
  const { resource } = useMetaLayoutContext();
  useScrollTopOnMount();
  useBoneBackgroundColor();

  return (
    <QuizWrapperLayout setLink={setLink}>
      <FDStack direction={'column'} spacing={4} {...dataAttrs('question-container')}>
        <FDStack direction={'column'} justifyContent={'center'} alignItems={'center'}>
          <ProgressBar />
        </FDStack>
        <QuestionCard key={resource.link('self').url()} />
      </FDStack>
    </QuizWrapperLayout>
  );
};

export { PicklistQuestion };
